import React, { useEffect, useState } from 'react'
import useUserListingStyles from './styles'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import ClearIcon from '@mui/icons-material/Clear'
import { Grid } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { useTheme } from '@mui/material/styles'
import {
  FetchUsersListNew,
  FetchPlantListNew,
  DeleteUserNew,
  RemovePlantToUserNew,
  AddPlantToUserNew,
} from '../../services/api'
import Addplantimg from '../../assets/images/add1.svg'
import Deleteplantimg from '../../assets/images/delete1.svg'
import Button from '@mui/material/Button'
import dayjs from 'dayjs'
import PlantSelection from '../Settings/components/AddExternalUserspage/utils/PlantSelection'

const UserListing = () => {
  const classes = useUserListingStyles()

  const theme = useTheme()
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  const [open, setOpen] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [email, setEmail] = React.useState('')
  const [deleteuserEmail, setDeleteuserEmail] = React.useState('')
  // allPlants holds the complete fetched list (across all pages)
  const [allPlants, setAllPlants] = useState([])
  // modalPlantList is the filtered list shown in the "Add Plant To User" dialog
  const [modalPlantList, setModalPlantList] = useState([])
  const [usersList, setUsersList] = React.useState([])
  const [userId, setUserId] = useState('')
  const [deleteuserId, setDeleteUserId] = useState('')
  const [deleteplantId, setDeletePlantId] = useState('')
  const [deleteplantUserId, setDeletePlantUserId] = useState('')
  const [deleteplantName, setDeletePlantName] = useState('')
  const [openDeletePlant, setOpenDeletePlant] = useState(false)
  const [filterType, setFilterType] = useState('client')
  const [filteredUsersList, setFilteredUsersList] = useState([])
  const [plantIds, setPlantIds] = React.useState([])
  const [errors, setErrors] = useState({
    personName: '',
  })
  const token = localStorage.getItem('accessToken')

  useEffect(() => {
    fetchUsers(filterType)
  }, [filterType])

  const fetchUsers = (type) => {
    FetchUsersListNew(token, type).then((resp) => {
      if (resp?.data) {
        setUsersList(resp?.data?.data)
        //console.log("Users", resp?.data?.data)
        setFilteredUsersList(resp?.data?.data)
      } else {
      }
    })
  }

  // Fetch all plants (handles backend pagination) and keep a single master list
  useEffect(() => {
    const fetchAllPlants = async () => {
      try {
        const Order = '1'
        const limit = 100
        let offset = 0
        let aggregated = []
        while (true) {
          const resp = await FetchPlantListNew(
            dayjs().format('YYYY-MM-DD'),
            token,
            Order,
            limit,
            offset
          )
          const batch = resp?.data?.data || resp?.data?.plants || []
          aggregated = aggregated.concat(batch)
            // Stop if fewer than limit returned (last page) or no items
          if (batch.length < limit || batch.length === 0) break
          offset += batch.length
        }
        setAllPlants(aggregated)
      } catch (e) {
        console.error('Failed to fetch all plants', e)
      }
    }
    fetchAllPlants()
  }, [token])

  useEffect(() => {
    fetchUsers(filterType)
    // Refresh full plant list whenever dialog actions may have changed assignments
    const refreshPlants = async () => {
      try {
        const Order = '1'
        const resp = await FetchPlantListNew(
          dayjs().format('YYYY-MM-DD'),
          token,
          Order,
          100,
          0
        )
        const initial = resp?.data?.data || resp?.data?.plants || []
        setAllPlants(initial)
      } catch (e) {
        console.error('Plant refresh failed', e)
      }
    }
    refreshPlants()
  }, [openDelete, openDeletePlant, filterType, token])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDeleteOpen = () => {
    setOpenDelete(true)
  }

  const handleDeleteClose = () => {
    setOpenDelete(false)
  }

  const handleOpenDeleteUser = (Data) => {
    setDeleteUserId(Data?.userId)
    setDeleteuserEmail(Data?.email)
    handleDeleteOpen()
  }

  const handleDeleteUser = () => {
    DeleteUserNew(deleteuserId, token).then((resp) => {
      if (resp?.data) {
        handleDeleteClose()
      } else {
      }
    })
  }

  const getFilteredPlantList = (userData) => {
    const assignedPlantIds = userData?.plants?.map((plant) => plant.id) || []
    return allPlants.filter((plant) => !assignedPlantIds.includes(plant.id))
  }

  const handleAddplant = (Data) => {
    setUserId(Data?.userId)
    setEmail(Data?.email)
    const availablePlants = getFilteredPlantList(Data)
    setModalPlantList(availablePlants)
    handleOpen()
  }

  const handleAddUser = () => {
    const Data = {
      userId: userId,
      plantIds: plantIds,
    }

    AddPlantToUserNew(Data, token).then((resp) => {
      if (resp?.data) {
        handleClose()
      } else {
      }
    })
  }

  const handleChangePlantName = (event) => {
    const {
      target: { value },
    } = event
    setPlantIds(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    setErrors({ ...errors, personName: '' })
  }

  const handleDeletePlant = () => {
    const PlantData = {
      userId: deleteplantUserId,
      plantIds: [deleteplantId],
    }
    RemovePlantToUserNew(PlantData, token).then((resp) => {
      if (resp?.data) {
        handleDeletePlantClose()
      } else {
      }
    })
  }

  const handleOpenDeletePlantFromUser = (Data, plant) => {
    setDeletePlantId(plant?.id)
    setDeletePlantUserId(Data?.userId)
    setDeletePlantName(plant?.plantName)
    handleDeletePlantOpen()
  }

  const handleDeletePlantOpen = () => {
    setOpenDeletePlant(!openDeletePlant)
  }

  const handleDeletePlantClose = () => {
    setOpenDeletePlant(!openDeletePlant)
  }

  useEffect(() => {
    if (usersList) {
      if (filterType === 'all') {
        setFilteredUsersList(usersList)
      } else {
        const filtered = usersList.filter(
          (user) => user.type.toLowerCase() === filterType
        )
        setFilteredUsersList(filtered)
      }
    }
  }, [filterType, usersList])

  const handleFilterChange = (event) => {
    setFilterType(event.target.value)
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '13px',
          padding: '0 0',
        }}
      >
        <FormControl sx={{ minWidth: 140 }}>
          <InputLabel id="type-filter-label">Filter by Type</InputLabel>
          <Select
            labelId="type-filter-label"
            id="type-filter"
            value={filterType}
            label="Filter by Type"
            onChange={handleFilterChange}
          >
            <MenuItem value="client">Clients</MenuItem>
            <MenuItem value="investor">Investors</MenuItem>
          </Select>
        </FormControl>
      </div>

      <Grid container spacing={2}>
        <table className={classes.tableStyle}>
          <thead>
            <tr>
              <th className={classes.thStyle}>Name</th>
              <th className={classes.thStyle}>Email</th>
              <th className={classes.thStyle}>Type</th>
              <th className={classes.thStyle}>Plants</th>
              <th className={classes.thStyle}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {usersList?.map((Data) => (
              <tr>
                <td className={classes.tdStyle}>{Data?.name}</td>
                <td className={classes.tdStyle}>{Data?.email}</td>
                <td className={classes.tdStyle}>
                  {' '}
                  {Data?.type
                    ? Data.type.charAt(0).toUpperCase() + Data.type.slice(1)
                    : ''}
                </td>
                <td className={classes.tdStyle}>
                  {Data?.plants?.map((plant) => (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                      }}
                    >
                      <div
                        style={{
                          width: '80%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {plant?.plantName}
                      </div>
                      <div
                        style={{
                          width: '20%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          className={classes.iconStyle}
                          onClick={() =>
                            handleOpenDeletePlantFromUser(Data, plant)
                          }
                          src={Deleteplantimg}
                          alt="delete plant icon"
                        ></img>
                      </div>
                    </div>
                  ))}
                </td>
                <td className={classes.tdStyle}>
                  <div className={classes.Rowstyle}>
                    <img
                      className={classes.iconStyle}
                      onClick={() => handleAddplant(Data)}
                      src={Addplantimg}
                      alt="Addplant icon"
                    ></img>

                    <img
                      className={classes.iconStyle}
                      onClick={() => handleOpenDeleteUser(Data)}
                      src={Deleteplantimg}
                      alt="delete user icon"
                    ></img>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Grid>

      <Dialog
        className="businessview_dialog"
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">Add Plant To User</div>

            <DialogActions>
              <ClearIcon onClick={handleClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <PlantSelection
                personName={plantIds}
                handleChangePlantName={handleChangePlantName}
                plantList={modalPlantList}
                errors={errors}
                theme={theme}
                MenuProps={MenuProps}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div>{email}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <button onClick={handleAddUser} className="save_btn">
              Save
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        className="Delete_dialog"
        open={openDelete}
        onClose={handleDeleteClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">
              {' '}
              Are you sure you want to delete this User?
            </div>

            <DialogActions>
              <ClearIcon onClick={handleDeleteClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                Email Id
              </div>
              <div>{deleteuserEmail}</div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                User Id
              </div>
              <div>{deleteuserId}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={handleDeleteClose}>Disagree</Button>
            <Button onClick={handleDeleteUser} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog
        className="Delete_dialog_"
        open={openDeletePlant}
        onClose={handleDeletePlantClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="h_1">
              {' '}
              Are you sure you want to delete this Plant?
            </div>
            <DialogActions>
              <ClearIcon onClick={handleDeletePlantClose} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Plant</div>
              <div>{deleteplantName}</div>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                User Id
              </div>
              <div>{deleteplantUserId}</div>
            </Grid>
          </Grid>

          <DialogActions>
            <Button onClick={handleDeleteClose}>Disagree</Button>
            <Button onClick={handleDeletePlant} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  )
}

UserListing.propTypes = {}

export default UserListing
